function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// 주어진 범위 안의 기본 탭만 연다. 범위를 안 주면 문서 전체를 본다.
// assets/section-lazy-render.js 가 지연 삽입한 섹션을 넘겨 이 함수를 부른다.
// 그쪽은 예전부터 window.openDefaultTabs 를 부르고 있었으나 노출하는 곳이 없어
// 조건이 늘 거짓이었고, 지연 섹션의 탭 초기화가 조용히 건너뛰어졌다.
function openDefaultTabs(root) {
  (root || document).querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
}
window.openDefaultTabs = openDefaultTabs;

// 이 파일은 한 문서에서 두 번 실릴 수 있다. 지연 섹션을 Section Rendering API 로
// 받아올 때 sections/featured-products.liquid 의 `unless template.name == 'index'`
// 가 재요청 경로에서 참이 되어 <script> 를 딸려 보내기 때문이다.
//
// 가드가 없으면 두 번째 실행이 문서 전역의 [data-default-open] 을 다시 클릭해,
// 사용자가 다른 섹션에서 골라 둔 탭이 첫 탭으로 되돌아간다. 스크롤을 내리다
// 갑자기 위쪽 탭이 바뀌는 형태라 에러도 없고 화면도 멀쩡해 QA 로 안 잡힌다.
if (!window.__tabManagerReady) {
  window.__tabManagerReady = true;

  // show the first tabs by default on load - data-default-open
  openDefaultTabs(document);
  window.addEventListener("shopify:section:load", () => {
    openDefaultTabs(document);
  });
}
